<style lang="scss" scoped>
.totals {
	min-height: 300px;
	&__header {
		@include flex-center;
		margin-bottom: 20px;
		h3 {
			margin-bottom: 0;
		}
		&__actions {
			margin-left: auto;
		}
	}
	&__wider {
		width: 200px !important;
	}
}
</style>

<template lang="pug">
	el-card.totals(v-loading="$apollo.loading")
		.totals__header
			h3 Data totals
			.totals__header__actions
				el-button(size="medium", icon="fe fe-refresh-cw icon-only", @click="$apollo.queries.Counts.refetch()")
		el-row(:gutter='30', v-if="school")
			el-col(:span="6", v-for="i of Counts", :key="i.id")
				table.data
					tr(v-for="r in i")
						td.totals__wider {{ r.niceName }}
						td {{ r.count ? r.count.toLocaleString() : 0 }}
</template>

<script>
import gql from "graphql-tag";
import { groupBy } from "lodash";

export default {
	name: "Statistics",
	props: {
		school: {
			required: true,
			type: Object
		}
	},

	apollo: {
		Counts: {
			query: gql`
				query DataCounts($id: String!) {
					School(id: $id) {
						id
						DataCounts {
							niceName
							count
						}
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			variables() {
				return {
					id: this.school.id
				};
			},
			update: r => groupBy(r.School.DataCounts, row => r.School.DataCounts.indexOf(row) % 4)
		}
	}
};
</script>
